<template>
	<div class="modal">
		<div class="modal__bg" @click="$emit('close')"></div>
		<div class="modal__video">
			<div class="modal__close"></div>
			<youtube :video-id="video" ref="youtube" :player-vars="playerVars" ></youtube>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueYoutube from 'vue-youtube'

	Vue.use(VueYoutube)
	export default {
		name: 'VideoModal',
		props: ['video'],
		data() {
			return {
				playerVars: {
					autoplay: 1
				}
			}
		},
	}
</script>

<style lang="sass">
	.modal
		position: fixed
		width: 100vw
		height: 100vh
		top: 0
		left: 0
		z-index: 9999999999999999
		display: flex
		align-items: center
		justify-content: center
		&__bg
			width: 100%
			position: fixed
			top: 0
			left: 0
			height: 100%
			cursor: pointer
			background-color: rgba(0,0,0,0.5)
		&__video
			position: relative
			z-index: 100000
			width: 80vw
			background-color: #333
			height: 45vw
			@media screen and (max-width: 1000px)
				width: 80vmin
				height: 142vmin
			iframe
				width: 100%
				height: 100%

</style>